export const not = (a, b) => {
  return a.filter((value) => b.indexOf(value) === -1);

  //Returns items that exists in a but not not in b
};

export const intersection = (a, b) => {
  return a.filter((value) => b.indexOf(value) !== -1);
};
//intersection : takes a and b arrays , Returns : filter of checked
export const union = (a, b) => {
  return [...a, ...not(b, a)];
};

export const isEditable = (value, requisitionID) => {
  let values = value.split("-");

  if (values.length < 2) {
    return false;
  } else if (values[1] === requisitionID) {
    return true;
  } else {
    return false;
  }
};
